import toast from 'react-hot-toast';

export const isFormValid = (formData, t) => {
  if (formData.tipMasine === null || formData.tipMasine === '') {
    toast.error(`${t('machineType')} ${t('isRequired')}`);
    return true;
  }

  if (
    formData.idKupca === null ||
    formData.idKupca === '' ||
    formData.idKupca === 0
  ) {
    toast.error(`${t('client')} ${t('isRequired')}`);
    return true;
  }
  if (
    formData.sifra === null ||
    formData.sifra === '' ||
    formData.sifra === 0
  ) {
    toast.error(`${t('machineRobotMachine')} ${t('isRequired')}`);
    return true;
  }

  return false;
};
